






import { Component, Mixins, Prop } from "vue-property-decorator";
import { instanceOfISeedAccessible } from "../../../../../../domain/developer";
import { IItem } from "../../../../../../domain/document/items";
import JsonViewer from "../../../../../system/viewers/JsonViewer.vue";

@Component({
  components: {
    jsonViewer: JsonViewer,
  }
})
export default class EntityViewer extends Mixins() {
  @Prop()
  source: IItem;

  get displaySource(): IItem {
    // そのままjson表示するとseedの内容が表示されてしまうのでseedを除去したcloneを作る.
    if (!this.source) {
      return null;
    }
    const cloned = this.source.clone();
    if (instanceOfISeedAccessible(cloned)) {
      cloned.seed = undefined;
    }
    return cloned;
  }
}
